import { Checkbox } from 'react-native-paper';
import React from 'react';
import { View } from 'react-native';

import { Typography } from '@components/Typography';
import { makeStyles } from '@providers/Theme';
import { GridContainer, GridItem, GridItemSpanValue } from '@components/Grid';

export type CheckboxGroupItem = {
  value: string;
  label: string;
  details?: React.ReactNode;
};

type CheckboxGroupProps = {
  value?: CheckboxGroupItem[];
  items: CheckboxGroupItem[];
  testID?: string;
  size?: GridItemSpanValue;
  onItemPress?: (item: CheckboxGroupItem, value: string) => void;
};

const useStyles = makeStyles({
  root: {},
  listItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  item: {
    flex: 1,
  },
  label: {
    flex: 1,
  },
  children: {
    marginHorizontal: 24,
  },
  grid: {
    backgroundColor: 'white',
    width: '100%',
  },
});

export const CheckboxGroup: React.FC<CheckboxGroupProps> = ({
  value: checkedValues = [],
  items,
  testID,
  onItemPress,
}) => {
  const styles = useStyles();

  const isItemChecked = (item: CheckboxGroupItem) => {
    return checkedValues.find((item_) => item_.value === item.value);
  };

  return (
    <View style={styles.root} testID={testID}>
      <GridContainer classes={{ root: styles.grid }} testID="container">
        {items.map((item, i) => (
          <GridItem xs={12} key={'checkbox-' + i}>
            <View style={styles.listItem} testID="view">
              <Checkbox
                status={isItemChecked(item) ? 'checked' : 'unchecked'}
                onPress={() => {
                  onItemPress?.(item, item.value);
                }}
                color="#F02A00"
                testID={'checkbox-' + i}
              />
              <Typography
                size={{ xs: 'sm', lg: 'md' }}
                weight="medium"
                style={styles.label}>
                {item.label}
              </Typography>
            </View>
            {item.details && isItemChecked(item) && (
              <View style={styles.children}>{item.details}</View>
            )}
          </GridItem>
        ))}
      </GridContainer>
    </View>
  );
};
